// src/session/sessionKeys.ts
var TOKEN = "t";
var TOKEN_EXPIRATION = "t_expiration";
var USER_DATA = "r";

// src/session/sessionCodec.ts
function encodeUserData(user) {
  const json = JSON.stringify(user);
  return base64Encode(json);
}
function decodeUserData(raw) {
  try {
    const json = base64Decode(raw);
    const user = JSON.parse(json);
    if (!user?.externalId) return null;
    return user;
  } catch {
    return null;
  }
}
function encodeTokenExpiration(epochMs) {
  return String(epochMs);
}
function decodeTokenExpiration(raw) {
  const n = Number(raw);
  if (isNaN(n) || !isFinite(n) || n <= 0) return null;
  return n;
}
function base64Encode(input) {
  const g = globalThis;
  if (typeof g.btoa === "function") {
    return g.btoa(unescape(encodeURIComponent(input)));
  }
  if (g.Buffer) {
    return g.Buffer.from(input, "utf-8").toString("base64");
  }
  throw new Error("No base64 encoder available in this runtime");
}
function base64Decode(input) {
  const g = globalThis;
  if (typeof g.atob === "function") {
    return decodeURIComponent(escape(g.atob(input)));
  }
  if (g.Buffer) {
    return g.Buffer.from(input, "base64").toString("utf-8");
  }
  throw new Error("No base64 decoder available in this runtime");
}

// src/session/createSessionManager.ts
function createSessionManager(storage) {
  const getSession = () => {
    const token = storage.getItem(TOKEN);
    const expRaw = storage.getItem(TOKEN_EXPIRATION);
    const userRaw = storage.getItem(USER_DATA);
    if (!token || !expRaw || !userRaw) return null;
    const tokenExpiration = decodeTokenExpiration(expRaw);
    const user = decodeUserData(userRaw);
    if (!tokenExpiration || !user) return null;
    return { token, tokenExpiration, user };
  };
  const setSession = (data) => {
    storage.setItem(TOKEN, data.token);
    storage.setItem(
      TOKEN_EXPIRATION,
      encodeTokenExpiration(data.tokenExpiration)
    );
    storage.setItem(USER_DATA, encodeUserData(data.user));
  };
  const clearSession = () => {
    storage.removeItem(TOKEN);
    storage.removeItem(TOKEN_EXPIRATION);
    storage.removeItem(USER_DATA);
  };
  const isSessionValid = (session) => {
    const s = session ?? getSession();
    if (!s?.token || !s?.user?.externalId) return false;
    if (!s?.tokenExpiration) return false;
    return Date.now() < s.tokenExpiration;
  };
  const isAuthenticated = () => isSessionValid(getSession());
  return {
    getSession,
    setSession,
    clearSession,
    isAuthenticated,
    isSessionValid
  };
}

// src/guards/routeMatcher.ts
function matchPath(pathname, rules) {
  const clean = normalize(pathname);
  return rules.some((rule) => {
    const r = normalize(rule);
    if (r.endsWith("/*")) {
      const base = r.slice(0, -2);
      return clean === base || clean.startsWith(base + "/");
    }
    return clean === r;
  });
}
function normalize(path) {
  if (!path.startsWith("/")) path = "/" + path;
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  return path;
}

// src/guards/createAuthGuard.ts
function createAuthGuard(config, sessionManager) {
  const callbackParam = config.callbackParam ?? "callbackUrl";
  const decide = (pathname) => {
    const session = sessionManager.getSession();
    const isValid = sessionManager.isSessionValid(session);
    const isAuthRoute = matchPath(pathname, config.authPaths);
    const isProtectedRoute = matchPath(pathname, config.protectedPaths);
    if (isProtectedRoute && !isValid) {
      const to = `${config.loginPath}?${callbackParam}=${encodeURIComponent(pathname)}`;
      return { action: "redirect", to };
    }
    if (isAuthRoute && isValid) {
      return { action: "redirect", to: config.homePath };
    }
    return { action: "allow" };
  };
  return { decide };
}

export { TOKEN, TOKEN_EXPIRATION, USER_DATA, createAuthGuard, createSessionManager, decodeTokenExpiration, decodeUserData, encodeTokenExpiration, encodeUserData, matchPath };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map